const { DEPOSIT_24_MONTHS_RETENTION_CMS_KEY } = require('constants/hiringProductInformation');

module.exports = {
    title: 'contractsView-contractsView_depositTwentyFourMonthsRetentionStep1Title',
    order: 1,
    footer_text: '',
    position: 'first',
    components: [
        {
            id_component: 'contract-info',
            id: 'text-info',
            cms_key: DEPOSIT_24_MONTHS_RETENTION_CMS_KEY,
            services: [
                {
                    propName: 'requestReferenceStandard',
                    params: {},
                    alreadyCalled: false
                }
            ]
        },
        {
            id_component: 'legal-information'
        }
    ]
};
